// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"9018b63d","188":"0f54f3b0","343":"752e410f","517":"dbefbb62","584":"83eb27a1","591":"eecac055","652":"0a9eed44","725":"b1c424c7","846":"2471f1e6"}[chunkId] + ".chunk.js";
};